
function initGlossaryLinks() {
  const glossaryLinks = document.querySelectorAll<HTMLElement>('a[href^="#glossary-"]');
  
  if (glossaryLinks.length < 1) return;

  glossaryLinks.forEach((link) => {
    link.addEventListener("click", handleGlossaryLinkClick);
  });

  function handleGlossaryLinkClick(event: MouseEvent) {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const glossaryId = target.getAttribute("href");
    if(!glossaryId) return;

    const parentContainer = target.closest('.accordion-body-content') ? target.closest('.accordion-body-content') : document.querySelector('#main');
    const glossaryAccordion = parentContainer?.querySelector<HTMLElement>(glossaryId);
    if(!glossaryAccordion) return;

    const glossaryAccordionLocation = glossaryAccordion.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({top: glossaryAccordionLocation, behavior: "smooth"});
  }
}



initGlossaryLinks();